import Group from 'shared/symbols/Group';
import Image from 'shared/symbols/Image';
import Rectangle from 'shared/symbols/Rectangle';
import Scene from 'shared/symbols/Scene';
import Stage from 'shared/symbols/Stage';
import Text from 'shared/symbols/Text';
import Carousel from './Carousel';
import Disclaimer from './Disclaimer';
import Replay from './Replay';
import Video from './Video';
var symbolMap = {
    carousel: Carousel,
    disclaimer: Disclaimer,
    group: Group,
    image: Image,
    rectangle: Rectangle,
    replay: Replay,
    scene: Scene,
    stage: Stage,
    text: Text,
    video: Video,
};
export default symbolMap;
